import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-local-button",
    styleUrls: ["./local-button.component.scss"],
    templateUrl: "./local-button.component.html",
    standalone: false
})
export class FUILocalButtonComponent extends FUIButtonComponent{

}
